import { useState } from "react";
import Auth from "../../../Auth";
import { GenerateResponse } from "./types";

interface UseImageGenerationResult {
  loading: boolean;
  imageUrl: string | null;
  result: GenerateResponse | null;
  error: string;
  generate: (endpoint: string, body: Record<string, unknown>) => Promise<void>;
  reset: () => void;
}

export function useImageGeneration(): UseImageGenerationResult {
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const [result, setResult] = useState<GenerateResponse | null>(null);
  const [error, setError] = useState("");

  const reset = () => {
    setImageUrl(null);
    setResult(null);
    setError("");
  };

  const generate = async (endpoint: string, body: Record<string, unknown>) => {
    if (loading) return;
    setLoading(true);
    reset();
    try {
      const response: GenerateResponse = await Auth.fetchWithIdToken(endpoint, body);
      setResult(response);
      setImageUrl(response.imageUrl);
    } catch (err) {
      // Auth.fetchWithIdToken rejects with an Error whose message is the server's `error` string.
      setError(err instanceof Error ? err.message : "An unknown error occurred");
    } finally {
      setLoading(false);
    }
  };

  return { loading, imageUrl, result, error, generate, reset };
}
